<!-- eslint-disable -->
<template lang="pug">
    .box
        .box-body(:class="{'box-body_game-started': isGrayBackground}")
            game-header(
                v-if="!isLoading",
                :key="headerKey",
                :amount-of-played-rounds="currentStageIndex + 1",
                :amount-of-rounds="amountOfRounds",
                @soundStateChanged="headerKey = !headerKey",
                :show-rounds="true",
                :is-battle="true"
            )
            .custom-loader(v-if="isLoading")
                img(src="../../assets/images/battles/loader.png")
            div(
                v-else-if="currentGame",
                :is="currentGame.slug",
                :type="currentGame.slug",
                :exercise-id="currentGame.id",
                :answer-duration="currentGame.parameters.default.answerDuration",
                :opponent="opponent",
                :calculating-answers="calculatingAnswers",
                :user-score="userScore",
                :opponent-score="opponentScore",
                :is-last-game-in-battle="isLastGameInBattle",
                :battle-game-parameters="currentGame",
                gameType="battle",
                @componentMounted="isGrayBackground = true"
                @finish="setWaitingForCalculatingAnswers"
            )
</template>

<script>
    /*eslint-disable*/
    import BattleApi from '../../api/battle';
    import { mapState } from 'vuex';

    import GameHeader from '../trainer/GameHeader.vue';
    import _ from "lodash";
    const AdditionAndSubtraction = () => import('../trainer/games/addition-and-subtraction/PlayBox.vue');
    const AdditionAndSubtractionWithTime = () =>
        import('../trainer/games/addition-and-subtraction-with-time/PlayBox.vue');
    const Schulte = () => import('../trainer/games/schulte/PlayBox.vue');
    const SequenceOfNumbers = () => import('../trainer/games/sequence-of-numbers/PlayBox.vue');
    const AssembleTheNumber = () => import('../trainer/games/assemble-the-number/PlayBox.vue');
    const InteractiveFlashCards = () => import('../trainer/games/interactive-flash-cards/PlayBox.vue');
    const Navigator = () => import('../trainer/games/navigator/PlayBox.vue');
    const Anzan = () => import('../trainer/games/anzan/PlayBox.vue');
    const AnzanWithTime = () => import('../trainer/games/anzan-with-time/PlayBox.vue');
    const MultiplicationAndDivision = () => import('../trainer/games/multiplication-and-division/PlayBox.vue');
    const Equation = () => import('../trainer/games/equation/PlayBox.vue');
    const Puzzle = () => import('../trainer/games/puzzle/PlayBox.vue');
    const TransferSyllables = () => import('../trainer/games/transfer-syllables/PlayBox.vue');
    const HardSoftConsonants = () => import('../trainer/games/hard-soft-consonants/PlayBox.vue');
    const DivideItRight = () => import('../trainer/games/divide-it-right/PlayBox.vue');
    const ChooseItRight = () => import('../trainer/games/choose-it-right/PlayBox.vue');
    const DivideUnstressedVowels = () => import('../trainer/games/divide-unstressed-vowels/PlayBox.vue');
    const WordStructure = () => import('../trainer/games/word-structure/PlayBox.vue');
    const SentenceParsing = () => import('../trainer/games/sentence-parsing/PlayBox.vue');
    const VocabularyWordsRus = () => import('../trainer/games/vocabulary-words-rus/PlayBox.vue');
    const TranscriptionInWord = () => import('../trainer/games/transcription-in-word/PlayBox.vue');
    const LettersSoundsSyllables = () => import('../trainer/games/letters-sounds-syllables/PlayBox.vue');
    const VoicedAndDeafConsonants = () => import('../trainer/games/voiced-and-deaf-consonants/PlayBox.vue');
    const PartsOfSpeech = () => import('../trainer/games/parts-of-speech/PlayBox.vue');
    const ParsingSentencePartsSpeech = () => import('../trainer/games/parsing-sentence-parts-speech/PlayBox.vue');
    const GenericWords = () => import('../trainer/games/generic-words/PlayBox.vue');
    const VerbTenses = () => import('../trainer/games/verb-tenses/PlayBox.vue');
    const SortOneMany = () => import('../trainer/games/sort-one-many/PlayBox.vue');
    const PunctuationMarks = () => import('../trainer/games/punctuation-marks/PlayBox.vue');
    const Alphabet = () => import('../trainer/games/alphabet/PlayBox.vue');
    const ConnectThePuzzles = () => import('../trainer/games/connect-the-puzzles/PlayBox.vue');
    const Orthograph = () => import('../trainer/games/orthograph/PlayBox.vue');

    const UPDATE_ACTIVITY_SECONDS = 60;

    export default {
        props: {
            id: [Number, String],
            opponent: {
                type: Object,
                default: null,
            },
            gameDone: {
                type: [Boolean],
                default: false,
            },
            stageIndexOnBattleResume: {
                type: [Number, String],
                default: null,
            },
            gameIndexOnBattleResume: {
                type: [Number, String],
                default: null,
            },
            userScoreOnBattleResume: {
                type: [Number, String],
                default: null,
            },
            opponentScoreOnBattleResume: {
                type: [Number, String],
                default: null,
            },
        },
        beforeRouteLeave(to, from, next) {
            if (!['battle:bad-connection', 'battles:index', 'battle:result'].includes(to.name)) {
                this.pauseBattle();
            }
            clearTimeout(this.activityUpdateTimerId);
            this.$echo.leave(`battle-game-done.${this.user.id}`);
            next();
        },
        created() {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        mounted() {
            this.$echo.private(`battle-game-done.${this.user.id}`).listen('BattleGameDoneEvent', data => {
                if (this.handlingEventTimeout === null) {
                    this.handlingEventTimeout = setTimeout(() => this.gameDoneEvent(data), 5000);
                }
            });
            if (this.opponent) {
                this.fetchData();
            }
            this.updateBattleStatsActivity();
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        data() {
            return {
                isLoading: true,
                battle: null,
                isGrayBackground: false,
                currentStageIndex: this.stageIndexOnBattleResume || 0,
                currentGameIndex: this.gameIndexOnBattleResume || 0,
                calculatingAnswers: this.gameDone || false,
                handlingEventTimeout: null,
                userScore: this.userScoreOnBattleResume || 0,
                opponentScore: this.opponentScoreOnBattleResume || 0,
                amountOfRounds: 0,
                headerKey: true,
                activityUpdateTimerId: null,
            };
        },
        methods: {
            updateBattleStatsActivity() {
                this.activityUpdateTimerId = setInterval(() => {
                    BattleApi.updateActivity()
                        .then()
                        .catch(err => {
                            if (err && err.data && err.data.message) {
                                this.$toasted.error(this.$i18n.t(`errors.${err.data.message}`));
                            } else {
                                this.$toasted.error(this.$i18n.t(`errors.error_has_occurred`));
                            }
                            this.$router.push({ name: 'dashboard' });
                        });
                }, UPDATE_ACTIVITY_SECONDS * 1000);
            },
            fetchData() {
                this.isLoading = true;
                BattleApi.show(this.id, { course_type: _.kebabCase(this.course) })
                    .then(battle => {
                        this.battle = battle;
                        if (this.battle.levels && !this.battle.levels.length) {
                            this.$toasted.error(this.$root.$t('errors.battle_no_access'));
                            this.$router.push({ name: 'battles:index' });
                        }
                        this.amountOfRounds = this.battle.levels[0].stages.length;
                        this.isLoading = false;
                    })
                    .catch(err => {
                        if (err.data && err.data.status_code === 403) {
                            this.$toasted.error(this.$root.$t('errors.battle_no_access'));
                            this.$router.push({ name: 'dashboard' });
                        } else {
                            this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                        }
                    });
            },
            getNextGame() {
                this.handlingEventTimeout = null;
                this.isLoading = true;
                this.isGrayBackground = false;
                this.currentGameIndex += 1;
                if (this.currentGameIndex === this.battle.levels[0].stages[this.currentStageIndex].games.length) {
                    this.currentGameIndex = 0;
                    this.currentStageIndex += 1;
                    if (this.currentStageIndex === this.amountOfRounds) {
                        BattleApi.completeBattle({ opponentPoints: this.opponentScore })
                            .then(data => {
                                this.$toasted.info(this.$i18n.t('battle.battle_isEnded'));
                                this.$nextTick(() => {
                                    this.$router.push({
                                        name: 'battle:result',
                                        params: {
                                            id: this.id,
                                            isVictory: data.isVictory,
                                            isBattleDraw: data.isBattleDraw,
                                            isTrainingBattle: data.isTrainingBattle,
                                            isForceCompleted: false,
                                        },
                                    });
                                });
                            })
                            .catch(err => {
                                if (err.data && err.data.status_code === 403) {
                                    this.$toasted.error(this.$root.$t('errors.battle_no_access'));
                                    this.$router.push({ name: 'dashboard' });
                                } else {
                                    this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                                }
                            });
                    }
                }
                this.$nextTick(() => {
                    this.isLoading = false;
                });
            },
            pauseBattle() {
                BattleApi.pauseBattle({ stage_index: this.currentStageIndex, game_index: this.currentGameIndex })
                    .then()
                    .catch(err => {
                        if (err && err.data && err.data.message) {
                            this.$toasted.error(this.$i18n.t(`errors.${err.data.message}`));
                        } else {
                            this.$toasted.error(this.$i18n.t(`errors.error_has_occurred`));
                        }
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            cancelInvite() {
                BattleApi.cancelInvite()
                    .then(() => {
                        this.$echo.leave(`battle-game-done.${this.user.id}`);
                    })
                    .catch(err => {
                        if (err && err.data && err.data.message) {
                            this.$toasted.error(this.$i18n.t(`errors.${err.data.message}`));
                        } else {
                            this.$toasted.error(this.$i18n.t(`errors.error_has_occurred`));
                        }
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            beforeTabClosed() {
                this.pauseBattle();
                return null;
            },
            gameDoneEvent(event) {
                this.calculatingAnswers = false;
                BattleApi.updateGameData({ winnerId: event.winnerId })
                    .then(data => {
                        this.$nextTick(() => {
                            if (!event.isGameDraw) {
                                if (event.winnerId === this.user.id) {
                                    this.userScore += 1;
                                } else {
                                    this.opponentScore += 1;
                                }
                            }
                        });
                        this.$toasted.info(this.getGameResultText(event), {
                            position: 'top-center',
                            duration: 6000,
                            className: 'battle-game-result-toast',
                        });
                        setTimeout(this.getNextGame, 6200);
                    })
                    .catch(err => {
                        if (err && err.data && err.data.message) {
                            this.$toasted.error(this.$i18n.t(`errors.${err.data.message}`));
                        } else {
                            this.$toasted.error(this.$i18n.t(`errors.error_has_occurred`));
                        }
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            setWaitingForCalculatingAnswers() {
                this.$toasted.info(this.$i18n.t('trainer.trainer_gamePlayBox_gameCompleted'));
                this.calculatingAnswers = true;
            },
            getGameResultText(event) {
                if (this.currentGame.slug === 'Navigator') {
                    const userAttempts = event.exerciseStat.chain_of_attempts;
                    const opponentAttempts = event.opponentExerciseStat.chain_of_attempts;
                    event.exerciseStat.answers = this.getAmountOfCorrectAnswersForNavigator(userAttempts);
                    event.opponentExerciseStat.answers = this.getAmountOfCorrectAnswersForNavigator(opponentAttempts);
                }

                let result = {
                    score: event.exerciseStat.answers,
                    time: event.exerciseStat.execution_time,
                    opponentScore: event.opponentExerciseStat.answers,
                    opponentTime: event.opponentExerciseStat.execution_time,
                };
                if (event.isGameDraw) {
                    return this.$i18n.t('battle.battle_roundDraw', result);
                }
                return this.user.id === event.winnerId
                    ? this.$i18n.t('battle.battle_youWonRound', result)
                    : this.$i18n.t('battle.battle_youLostRound', result);
            },
            getAmountOfCorrectAnswersForNavigator(chainOfAttempts) {
                return chainOfAttempts.reduce((acc, example) => {
                    let isCorrectAnswer = _.find(example, { good: 1 });
                    return isCorrectAnswer ? ++acc : acc;
                }, 0);
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                course: state => state.trainer.course,
            }),
            currentGame() {
                if (
                    this.battle &&
                    this.battle.levels[0].stages[this.currentStageIndex] &&
                    this.battle.levels[0].stages[this.currentStageIndex].games[this.currentGameIndex] &&
                    this.battle.levels[0].stages[this.currentStageIndex].games[this.currentGameIndex].slug ===
                        'Anzan' &&
                    this.battle.levels[0].stages[this.currentStageIndex].games[this.currentGameIndex].parameters.default
                        .withTime
                ) {
                    this.battle.levels[0].stages[this.currentStageIndex].games[this.currentGameIndex].slug =
                        'AnzanWithTime';
                }
                return (
                    this.battle &&
                    this.battle.levels[0].stages[this.currentStageIndex] &&
                    this.battle.levels[0].stages[this.currentStageIndex].games[this.currentGameIndex]
                );
            },
            amountOfGamesInRound() {
                return this.amountOfRounds && this.battle.levels[0].stages[this.currentStageIndex].games.length;
            },
            isLastGameInBattle() {
                return (
                    this.currentStageIndex + 1 === this.amountOfRounds &&
                    this.currentGameIndex + 1 === this.amountOfGamesInRound
                );
            },
        },
        components: {
            GameHeader,
            AdditionAndSubtraction,
            AdditionAndSubtractionWithTime,
            Schulte,
            SequenceOfNumbers,
            AssembleTheNumber,
            InteractiveFlashCards,
            Navigator,
            Anzan,
            AnzanWithTime,
            Puzzle,
            Equation,
            MultiplicationAndDivision,
            TransferSyllables,
            HardSoftConsonants,
            DivideItRight,
            ChooseItRight,
            DivideUnstressedVowels,
            WordStructure,
            SentenceParsing,
            VocabularyWordsRus,
            TranscriptionInWord,
            LettersSoundsSyllables,
            VoicedAndDeafConsonants,
            PartsOfSpeech,
            ParsingSentencePartsSpeech,
            GenericWords,
            VerbTenses,
            SortOneMany,
            PunctuationMarks,
            Alphabet,
            ConnectThePuzzles,
            Orthograph,
        },
    };
</script>

<style scoped lang="scss">
    .custom-loader {
        width: 60px;
        height: 60px;
        margin: 0 auto;
        animation: spin 2s linear infinite;
    }
    @keyframes spin {
        100% {
            transform: rotate(360deg);
        }
    }

    .box {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        box-shadow: 0 0 54px #51a552;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $x-color-white;
        border-radius: $border-radius-40;
        padding: 30px;
        position: relative;
        @include media($sm) {
            border-radius: 40px;
            padding: 30px;
        }
        @media screen and (max-width: 575px) {
            border-radius: 0;
            padding: 0;
            box-shadow: none;
            position: static;
        }
    }
    .box-body {
        width: 100%;
        height: 100%;
        text-align: center;
    }
    .box-body_game-started {
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-40;
        padding: 30px;
        @include media($md) {
            padding: 30px;
        }
        @include media($sm) {
            padding: 15px;
        }
        @media screen and (max-width: 575px) {
            padding: 0;
            border-radius: 0;
        }
    }
</style>
